export default __webpack_public_path__ + "static/media/Roboto-Black.07a21e85.ttf";